export default "__VITE_PUBLIC_ASSET__50dbb467__"